import React from 'react'
import Markdown from '../../components/Markdown'
const { assembleText } = require('yatte')

const Static = ({ content, scope }) => {
  const text = assembleText(content, scope).value
  return (
    <Markdown>{text}</Markdown>
  )
}

export default Static
